export const DEFAULT_CONFIG = {
  nonce: Math.floor(Math.random()*1000000),
  account: 'atomicdropsx',
  name: 'claimdropkey',
  drop_id: 3873,
  table: 'authkeys',
};